<template>
    <section>
      
      <div class="columns">
<div :class="'column is-2'">
    <b-menu>
    <b-menu-list label="Dashboard">
      <b-menu-item label="My projects" active></b-menu-item>
      <!-- <b-menu-item label="Pre-trained models"  tag="router-link" to="/explore"></b-menu-item> -->
      
      <b-menu-item  label="Get started">
        <b-menu-item label="Quickstart" tag="a" target="_blank" href="https://docs.metatext.ai/v1/getting-started/get-started"></b-menu-item>
        <b-menu-item label="Guides & video tutorials" tag="a" target="_blank" href="https://docs.metatext.ai/v1/get-started/walk-through-demos"></b-menu-item>
        <b-menu-item label="API reference" tag="a" target="_blank" href="https://docs.metatext.ai/v1/api-reference/authentication"></b-menu-item>
      </b-menu-item>
    </b-menu-list>
    <b-menu-list>
      
      <b-menu-item label="Account" tag="router-link" to="/account/usage"></b-menu-item>

    </b-menu-list>
    <br>
    <b-menu-list label="Plan usage">
      <PlanUsage v-if="currentUser" :dashboard="true"/>
    </b-menu-list>
    <br>
    <b-menu-list label="Metatext community">
                    <div class="pt-1">
                        <p class="subtitle is-6">
                            Connect, get help and share insights with like-minded makers.
                        </p>
                        <b-field message="">
                        <b-button expanded type=" is-center" tag="a" href="https://discord.gg/PDWss5Fz79" target="_blank">
                            <svg xmlns="http://www.w3.org/2000/svg" height="15" viewBox="0 0 640 512"><path d="M524.5 69.8a1.5 1.5 0 0 0 -.8-.7A485.1 485.1 0 0 0 404.1 32a1.8 1.8 0 0 0 -1.9 .9 337.5 337.5 0 0 0 -14.9 30.6 447.8 447.8 0 0 0 -134.4 0 309.5 309.5 0 0 0 -15.1-30.6 1.9 1.9 0 0 0 -1.9-.9A483.7 483.7 0 0 0 116.1 69.1a1.7 1.7 0 0 0 -.8 .7C39.1 183.7 18.2 294.7 28.4 404.4a2 2 0 0 0 .8 1.4A487.7 487.7 0 0 0 176 479.9a1.9 1.9 0 0 0 2.1-.7A348.2 348.2 0 0 0 208.1 430.4a1.9 1.9 0 0 0 -1-2.6 321.2 321.2 0 0 1 -45.9-21.9 1.9 1.9 0 0 1 -.2-3.1c3.1-2.3 6.2-4.7 9.1-7.1a1.8 1.8 0 0 1 1.9-.3c96.2 43.9 200.4 43.9 295.5 0a1.8 1.8 0 0 1 1.9 .2c2.9 2.4 6 4.9 9.1 7.2a1.9 1.9 0 0 1 -.2 3.1 301.4 301.4 0 0 1 -45.9 21.8 1.9 1.9 0 0 0 -1 2.6 391.1 391.1 0 0 0 30 48.8 1.9 1.9 0 0 0 2.1 .7A486 486 0 0 0 610.7 405.7a1.9 1.9 0 0 0 .8-1.4C623.7 277.6 590.9 167.5 524.5 69.8zM222.5 337.6c-29 0-52.8-26.6-52.8-59.2S193.1 219.1 222.5 219.1c29.7 0 53.3 26.8 52.8 59.2C275.3 311 251.9 337.6 222.5 337.6zm195.4 0c-29 0-52.8-26.6-52.8-59.2S388.4 219.1 417.9 219.1c29.7 0 53.3 26.8 52.8 59.2C470.7 311 447.5 337.6 417.9 337.6z"/></svg> Join Discord channel
                        </b-button>
                        </b-field>
                    </div>
    </b-menu-list>
    
    <!-- <b-menu-list>
        <div class="cta-container">
                        <p>Upgrade your Metatext account for enhanced features!</p>
                        <br>
                        <b-button expanded @click="isModalPricingOpen = true" type="is-primary is-center">Upgrade</b-button>
                    </div>
    </b-menu-list> -->
  </b-menu>
    </div>
  
  <div class="column">
          <div class="columns">
            <div class="column is-2">
      <h2 class="title is-4">Projects <span v-if="projects.length > 0">({{ projectsFiltered.length }})</span></h2>
    </div>
    <div class="column">
      <b-field grouped position="is-right">
        <b-field><i class="fa fa-filter"></i></b-field>
        <b-field>
            
            <b-select v-model="modelType" size="is-smallx" expanded>
                <option value="all" selected>All</option>
                <option v-for="(item, index) in modelTypeList" :key="index" :value="item.id">{{ item.name }}</option>
        </b-select>
        
        </b-field>
        <!-- <b-field label="">

            <b-checkbox v-model="showTemplates" size="is-smallx" native-value="true" type="is-info">
              Show templates
            </b-checkbox>
        </b-field> -->
        <b-field>
            <!-- status -->
            <b-select v-model="status" size="is-smallx">
              <option value="all" selected>All</option>
              <option value="online">Online</option>
              <option value="training">Training</option>
              <option value="warning">Warning</option>
            </b-select>
        </b-field>
    </b-field>
</div>
        </div>
      <div id="models">
        
        
        <div class="boards-grid">
        <div class="card board-create" @click="createProject()">
            <div class="card-content info" type="is-info">
            <div class="content">
              <div class="media-content">
                <br>
                <p class="name title is-5 has-text-centered">
                  
                </p>
                <p class="name title is-5 is-info has-text-centered">
                    <i class="fa fa-plus" aria-hidden="true"></i>&nbsp;&nbsp;Create Project
                </p>
            </div>
            </div>
            </div>
        </div> 

        <router-link v-if="projects && projects.length > 0" class="card board" :to="(!model.datasetId)?`/projects/${model.id}/train`:(['classification'].includes(model.type)?`/projects/${model.id}/train`:`/projects/${model.id}/train`)" 
          v-for="(model, index) in projectsFiltered"
          :key="index">
          
          <div class="card-content info" type="is-info">
            <div class="content">
              <div class="media-content">
                <b-tag class="is-pulled-right" type="is-white" style="background-color: transparent;" v-if="model.model_metrics != undefined && 'f1score' in model.model_metrics">
                  <b-tooltip label="Score"
                      position="is-bottom"
                      type="is-light">
                      {{  (model.model_metrics["f1score"]*100).toFixed(0) }}%
                  </b-tooltip>
                </b-tag>
                
                
                <p class="name title is-5">
                  {{model.name}}
                </p>
                
                
                <p class="description is-6">
                  <span v-if="model.description != undefined">
                    {{ model.description }}
                  </span>
                  <span v-else>
                    &nbsp;
                  </span>
                </p>
              </div>
            </div>

                

            

            <div class="bottom-left">
                <b-tag size="small" type="is-info" v-if="['uploading', 'training', 'annotation'].includes(projectStatus(model).replace('model: ', '').replace('dataset: ',''))">
                    <b-button style="text-decoration: none;" type="is-ghost" size="is-small" :loading="true"></b-button>
                </b-tag>
                <b-tag size="small" type="is-warning" v-else-if="projectStatus(model).includes('warning')">
                    <i class="fa fa-exclamation-circle"></i>&nbsp;
                    <!-- {{ projectStatus(model).replace(': warning', '') }} -->
                </b-tag>
                <b-tag size="small" type="is-success" v-else-if="projectStatus(model).includes('online')">
                  <i class="fa fa-check"></i>&nbsp;
                </b-tag>
                <b-tag style="text-decoration: none;color: white;" size="small" type="is-light" v-else-if="projectStatus(model).includes('draft')">
                  {{ projectStatus(model).replace(':', '') }}
                </b-tag>
            </div>
            <div class="bottom-right">
                
                <b-tag type="is-secondary">
                  {{ model.type }}
                </b-tag>
            </div>
          </div>
        </router-link>

      </div>
    </div>
    <div v-if="projects && projects.length < 1">
    

    </div>
  

</div>
</div>

<!-- <footer class="footer">
  <div class="content has-text-left">
    <p>
      <strong>Bulma</strong> by <a href="https://jgthms.com">Jeremy Thomas</a>. The source code is licensed
      <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The website content
      is licensed <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">CC BY NC SA 4.0</a>.
    </p>
  </div>
</footer> -->
  
    <!-- MODALS -->
      <b-modal
          v-model="isModalProjectCreateOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Project"
          aria-modal  
          can-cancel
          full-screen
          scroll="keep">
          <template #default="props">
              <modal-project @close="props.close" :stepId="stepId"></modal-project>
          </template>
      </b-modal>

      <b-modal
          v-model="isModalPricingOpen"
          trap-focus
          has-modal-card
          :destroy-on-hide="false"
          aria-role="dialog"
          aria-label="Project"
          aria-modal
          full-screen
          :on-cancel="() => { $router.push('/') }"
          scroll="keep">
          <template #default="props">
            <modal-pricing @close="props.close" :stepId="stepId" :currentUser="currentUser"></modal-pricing>
          </template>
      </b-modal>
    </section>
    
  </template>
  
  <script>
  import { SidebarMenu } from 'vue-sidebar-menu'
  import 'vue-stepper-component'
  import ModalModel from '@/components/ModelCreate.vue'
  import ModalDataset from '@/components/DatasetCreate.vue'
  import ModalGetStarted from '@/components/GetStarted.vue'
  import ModalProject from '@/components/ProjectCreateNew.vue'
  import Pricing from '@/components/Pricing.vue'
  import PlanUsage from '@/components/PlanUsage.vue'
  import mixin from '@/utils/sharedFunctions.js'

  export default {
    mixins: [mixin],
    props: ["start", "stepId"],
    name: "Explore",
    data() {
      return {
        isStepsClickable: true,
        openSideMenu: true,
        isModalProjectCreateOpen: (this.start == 'create')?true:false,
        isModalPricingOpen: (this.start == 'pricing')?true:false,
        isModalModelCreateOpen: false,
        isModalDatasetCreateOpen: false,
        isModalGetStartedOpen: false,
        showTemplates: true,
        menu: [
                    {
                        header: true,
                        title: 'Main Navigation',
                        hiddenOnCollapse: true
                    },
                    {
                        href: '/',
                        title: 'Dashboard',
                        icon: 'fa fa-user'
                    },
                    {
                        href: '/charts',
                        title: 'Charts',
                        icon: 'fa fa-chart-area',
                        child: [
                            {
                                href: '/charts/sublink',
                                title: 'Sub Link'
                            }
                        ]
                    }
                ],
        items: [
          {
            name: "Get started", id: "get-started"
          },
        ],
        inputTaskList: [{id: 'text', name: 'Text'}, {id: 'pdf', name: 'PDF'}],
        inputTask: 'text',
        modelType: 'all',
        modelTypeList: [
            {id: 'classification', name: 'Classification'}, 
            {id: 'extraction', name: 'Extraction'}, 
            {id: 'summarization', name: 'Summarization'},
            {id: 'generation', name: 'Generation'}
        ],
        status: 'all',
      };
    },
    components: {
      "modal-get-started": ModalGetStarted,
      "modal-model": ModalModel,
      "modal-dataset": ModalDataset,
      "modal-project": ModalProject,
      "modal-pricing": Pricing,
      SidebarMenu,
      PlanUsage,
      
    },
    watch: {
      start: function (val) {
        this.isModalPricingOpen = (val == 'pricing')?true:false
      },
    },
    computed: {
      projects() {
        return [...this.$store.state.projects]
      },
      projectsFiltered() {
        return this.projects.filter(
            (project) => {
                if (this.modelType == 'all'){
                return true
                } else {
                return project.type == this.modelType
                }
            }
            ).filter(
            (project) => {
                if (this.status == 'all'){
                return true
                } else {
                return this.projectStatus(project).includes(this.status)
                }
            }
        )
      },
      datasets() {
        return [...this.$store.state.datasets]
      },
      models() {
        return [...this.$store.state.models]
      },
      projectsPublic() {
        return [...this.$store.state.projectsPublic]
      },
      currentUser() {
            return this.$store.state.currentUser;
      },
      currentOrg() {
            return this.$store.state.currentUser;
      },
    },
    methods:{
        createProject(){
            let hasPlan = Object.hasOwn(this.currentUser, 'plan') && Object.hasOwn(this.currentUser.plan, 'projectsLimit')
            if (hasPlan && this.currentUser.plan.projectsLimit <= this.projects.length){
                // alert user that project limit has gone
                this.isModalPricingOpen = true
            } else {
                setTimeout(() => {
                    this.$router.push(`/create`)
                },  1)
            }
            
        },
      projectStatus(project){
        if (!project.modelId) return ''

        if( "state" in project){
          if("train" in project.state && "status" in project.state.train){
            let status = project.state.train.status
            if (['running', 'queued'].includes(status)){
              return 'training'
            } else if (['complete'].includes(status) && project.model_metrics != undefined) {
              return 'online'
            } else if (['error', 'quota'].includes(status)) {
              return 'model: warning'
            }
          } else if ("upload" in project.state){
            let status = project.state.upload.status

            if (status != 'running' && status != 'complete'){
              return 'dataset: warning'
            } else if(status == 'running'){
              return 'uploading'
            } else if (status == 'complete') {
              return 'annotation'
            }
          }
        }

        return ''
      },
    },
    created() {

      
        
      this.$store.dispatch("currentUser").then( (user) => {
        const organizationId = (this.currentUser && this.currentUser.organizationId ? this.currentUser.organizationId : this.currentUser.id)
        this.$store.dispatch("retrieveAllProjects", this.currentUser);
        // this.$store.dispatch("retrieveAllDatasets", this.currentUser);
        // this.$store.dispatch("retrieveAllModels", this.currentUser);
        this.$store.dispatch("currentOrg", organizationId);
        const payloadUsageByUser = {
                userId: this.currentUser.id,
                usagePlanId: this.currentUser.apiUsagePlanId,
                apiKeyId: this.currentUser.apiKeyId
        }
        this.$store.dispatch("updateAPIUsageByUser", payloadUsageByUser);
      })
    },
        
      
  };
  </script>
  
  <style lang="scss" scoped>
.boards-grid-small {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 16px;
}

.boards-list {
    display: grid;
    gap: 16px;

  
    .board-create {
      cursor: pointer;
      border: dashed 4px #e6e4e4;
      border-radius: 0px;
      min-height: 10em;
    
      &:hover {
        border: dashed 4px #bdbdbd;
      }
    }
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
      min-height: 2em;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 10px;
        display:flex;
        flex-direction:column;
        justify-content:space-between
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }

        .bottom-left {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          left: 0.8em;
        }
        .bottom-right {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          right: 0.8em;
        }
      }
    }
}

.boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;

  
    .board-create {
      cursor: pointer;
      border: dashed 4px #e6e4e4;
      border-radius: 0px;
      min-height: 10em;
    
      &:hover {
        border: dashed 4px #bdbdbd;
      }
    }
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
      min-height: 10em;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 16px;
        display:flex;
        flex-direction:column;
        justify-content:space-between
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }

        .bottom-left {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          left: 0.8em;
        }
        .bottom-right {
          position: absolute;
          margin-top: auto;
          margin-bottom: 0.8em;
          bottom: 0;
          right: 0.8em;
        }
      }
    }
}
.footer {
  position: fixed;
  height: 0.3em;
  left: 0;
  bottom: 0;
  width: 100%;
  color: white;
  text-align: left;
}
  

.p-1 {
  padding: 1em;
}
.sidebar-page {
    display: flex;
    flex-direction: column;
    border: 0;
    border-radius: 0;
    box-shadow: none;
    width: 100%;
    min-height: 100%;
    // min-height: 100vh;
    .sidebar-layout {
        display: flex;
        flex-direction: row;
        border: 0;
    border-radius: 0;
    box-shadow: none;
        min-height: 100%;
        // min-height: 100vh;
    }
}
@media screen and (max-width: 1023px) {
    .b-sidebar {
        .sidebar-content {
            &.is-mini-mobile {
                &:not(.is-mini-expand),
                &.is-mini-expand:not(:hover):not(.is-mini-delayed) {
                    .menu-list {
                        li {
                            a {
                                span:nth-child(2) {
                                    display: none;
                                }
                            }
                            ul {
                                padding-left: 0;
                                li {
                                    a {
                                        display: inline-block;
                                    }
                                }
                            }
                        }
                    }
                    .menu-label:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}
@media screen and (min-width: 1024px) {
    .b-sidebar {
        .sidebar-content {
            &.is-mini {
                &:not(.is-mini-expand),
                &.is-mini-expand:not(:hover):not(.is-mini-delayed) {
                    .menu-list {
                        li {
                            a {
                                span:nth-child(2) {
                                    display: none;
                                }
                            }
                            ul {
                                padding-left: 0;
                                li {
                                    a {
                                        display: inline-block;
                                    }
                                }
                            }
                        }
                    }
                    .menu-label:not(:last-child) {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}
.is-mini-expand {
    .menu-list a {
        white-space: nowrap;
        overflow: hidden;
        box-shadow: none;
        text-overflow: ellipsis;
    }
}

$sidebar-box-shadow: 0 0 0 1px rgba(10, 10, 10, 0.1), 0 2px 3px rgba(10, 10, 10, 0.1);
$sidebar-background: #fff;
</style>